// extracted by mini-css-extract-plugin
export default {"block":"styles_block__JLlcy"};